/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AlertsResponse,
  HTTPValidationError,
} from '../models/index';
import {
    AlertsResponseFromJSON,
    AlertsResponseToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/index';

export interface GetAlertsApiV1AlertsGetRequest {
    instanceIds?: string | null;
}

/**
 * 
 */
export class AlertsApi extends runtime.BaseAPI {

    /**
     * Get all active Guardian alerts for the requested instances.  Guardian alerts are AI-generated alerts based on metric analysis and anomaly detection. These are different from native Ring/Artesca platform alerts (which are tracked as count metrics: platform_warning_alerts, platform_critical_alerts).  Args:     instance_ids: Comma-separated instance ids to scope the alerts     current_user: Authenticated user information     settings: Application settings     logger: Logger dependency     telemetry: Telemetry service dependency     access_token: Caller\'s bearer token, forwarded to customer-portal-api  Returns:     AlertsResponse object containing list of active Guardian alerts
     * Get Alerts
     */
    async getAlertsApiV1AlertsGetRaw(requestParameters: GetAlertsApiV1AlertsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AlertsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['instanceIds'] != null) {
            queryParameters['instance_ids'] = requestParameters['instanceIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/alerts/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AlertsResponseFromJSON(jsonValue));
    }

    /**
     * Get all active Guardian alerts for the requested instances.  Guardian alerts are AI-generated alerts based on metric analysis and anomaly detection. These are different from native Ring/Artesca platform alerts (which are tracked as count metrics: platform_warning_alerts, platform_critical_alerts).  Args:     instance_ids: Comma-separated instance ids to scope the alerts     current_user: Authenticated user information     settings: Application settings     logger: Logger dependency     telemetry: Telemetry service dependency     access_token: Caller\'s bearer token, forwarded to customer-portal-api  Returns:     AlertsResponse object containing list of active Guardian alerts
     * Get Alerts
     */
    async getAlertsApiV1AlertsGet(requestParameters: GetAlertsApiV1AlertsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AlertsResponse> {
        const response = await this.getAlertsApiV1AlertsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
